import { Paper, ToggleButton, ToggleButtonGroup } from '@mui/material';
import { selectScreenshareStreams } from 'features/layout/features/order/orderSlice';
import { styled } from '@mui/material/styles';
import { useSimulcast } from 'hooks/useSimulcast';
import { useAppSelector } from 'store/hooks';

type ScreenshareSimulcastControlsProps = {
  mid: string;
};

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '&:not(:first-of-type)': {
    marginTop: -1,
  },
  '& .MuiToggleButtonGroup-grouped': {
    borderRadius: 0,
    minWidth: 30,
    fontSize: 12,
    fontWeight: 500,
    padding: theme.spacing(1),
    color: theme.palette.text.primary,
    lineHeight: 1,
    '&.Mui-selected': {
      color: theme.palette.error.main,
    },
  },
}));

const ScreenshareSimulcastControls = ({ mid }: ScreenshareSimulcastControlsProps) => {
  const { substream, changeSubstream } = useSimulcast(mid);

  const screenshareStreams = useAppSelector((state) => selectScreenshareStreams(state));

  return (
    <Paper
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <StyledToggleButtonGroup
        value={substream}
        exclusive
        onChange={changeSubstream}
        aria-label="Substream controls"
      >
        <ToggleButton value={1}>H</ToggleButton>
        {screenshareStreams.length > 5 && <ToggleButton value={0}>L</ToggleButton>}
      </StyledToggleButtonGroup>
    </Paper>
  );
};

export default ScreenshareSimulcastControls;
